module.exports = __webpack_public_path__ + "static/media/068-djibouti.543f54f1.svg";